import React from "react";

const SectionHeader = ({ title }) => <p className="add-pay-request__section-title">{title}</p>;

export default SectionHeader;
